import { render } from "./TissuView.vue?vue&type=template&id=5664e39a"
import script from "./TissuView.vue?vue&type=script&lang=js"
export * from "./TissuView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__